import { createAuth0 } from "@auth0/auth0-vue";
import router from "@/router/router";

// enable useRefreshTokens and localstorage so that page refresh works
// in Safari, and other browsers blocking third-party cookies by default.
// nb "Allow Offline Access" must be set in the auth0 tenant API settings.
// https://community.auth0.com/t/why-is-authentication-lost-after-refreshing-my-single-page-application/56276

export const auth0 = createAuth0({
    clientId: import.meta.env.VITE_APP_AUTH0_CLIENT_ID,
    domain: import.meta.env.VITE_APP_AUTH0_DOMAIN,
    useRefreshTokens: true,
    cacheLocation: "localstorage",
    authorizationParams: {
        audience: "https://api.cosmosyachting.com",
        redirect_uri: import.meta.env.VITE_APP_AUTH0_CALLBACK_URL,
    },
    onRedirectCallback: (appState?: { targetUrl?: string }) => {
        console.debug('[Auth0] onRedirectCallback', appState);
        const stored = localStorage.getItem('postLoginRedirect') || undefined;
        const target = appState?.targetUrl || stored || window.location.pathname || '/';
        if (stored) localStorage.removeItem('postLoginRedirect');
        router.replace(target);
    },
});